<div class="usan-form-item">
  <button type="button" class="step-btn save-btn save-btn-style save-btn-text" 
    [ngClass]="isMobileDeviceSize ? 'save-btn__mobile' : 'save-btn__full'" (click)="saveDraft()">
      <mat-icon class="save-btn-icon">save</mat-icon>
      Save Draft
  </button>
</div>